module.exports = __webpack_public_path__ + "static/img/bg123.1f9308a7.png";